import { useState } from 'react';
import { tableHeadCells } from 'containers/pages/contacts/data';

/**
 * @function useContactExistList
 * @param {function} onGetContactId
 * @param {function} onMode
 * @returns {object}
 */
function useContactExistList(onGetContactId, onMode) {
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);

	const onPage = (e, newPage) => {
		setPage(parseInt(newPage));
	};

	const onRowsPerPage = (e) => {
		setRowsPerPage(parseInt(e.target.value, 10));
		setPage(0);
	};

	const onRow = (id) => {
		onGetContactId(id);
		onMode(false);
	};

	return {
		tableHeadCells,
		page,
		rowsPerPage,
		onPage,
		onRowsPerPage,
		onRow,
	};
}

export default useContactExistList;
